import React from 'react'
import PropTypes from 'prop-types'
import MediaCategoryItem from './MediaCategoryItem'

const MediaAssetsPage = ({ data }) => (
  <div className="mx-6 mt-3 md:mx-4 md:mt-5 lg:mx-0 lg:mt-6">
    <h1 className="mb-4 text-4xl text-blue-700">Media Assets</h1>
    <p className="mb-2 text-s text-gray-510 md:mb-0">
      You are free to use materials such as images, logos, survey results
      screenshots, and text that are copyrighted by Freedom Debt Relief – if you
      give proper attribution.
    </p>
    <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
      {data.map(({ key, slug, title }) => (
        <MediaCategoryItem key={key} slug={slug} title={title}>
          <div className="flex w-full items-center justify-center font-semibold">
            <a
              className="text-xl text-blue-700"
              href={`/media-assets/${slug}/`}
            >
              {title}
            </a>
          </div>
        </MediaCategoryItem>
      ))}
    </div>
  </div>
)

MediaAssetsPage.propTypes = {
  data: PropTypes.array,
}

MediaAssetsPage.defaultProps = {
  data: [],
}

export default MediaAssetsPage
